import React from 'react'
import './cohort3.css' 
import Modal from "../../components/Modal"
import "animate.css/animate.min.css"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import ContentPage from "../../components/content-page"
import Meta from "../../components/meta"
import mentConstant5 from '../../constant/mentConstant5'
import { Left } from 'react-bootstrap/lib/Media'
import MediaRight from 'react-bootstrap/lib/MediaRight'

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal direction="" className="teamdetails__wrapper" show={show} onHide={onHide}>
      <Modal.Header>
            <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
                    <div className="item_des">{activeItem.post}</div>
                    <div className="item_des">{activeItem.company}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
               
              
        <div className="item__desc force-overflow">
          <div className="item__desc_scr" style={{ padding:"0px 10px 0px 0px"}} dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
               
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  )
}

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
}

export class Index extends React.Component{
    constructor (args) {
    super(args)
    this.state = {
      activeItem: {},
      isShow: false
    }
    
  }

  
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {}
    })
  }


    render(){
        const { location } = this.props
        const { isShow } = this.state
      
        return(
            <ContentPage>
            <Meta title="Winpe ProClub Mentorship Program | Mentees: Cohort of 2025" description="A group of highly talented young women on their path to continued success." image={"https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg"} location={location} />
                <div className="mentees-wrapper" >
               <div className="container">
               <div className="heading"><h1>Mentees <br /><span></span> Cohort VI</h1></div>
               
               
               
                <div className="section_intro_text"> 
                  <p>A group of highly talented young women on their path to continued success.
</p> 
          {/*    <div className="heading"> <h1 className="heading">Application Criteria and Application Process</h1></div><br/><br/>
<ul style={{textAlign:"Left"}}><li>
Applicants should be currently employed as an investment professional or as a founder/ co-founder of a funded start-up.</li> 
<li > In case an applicant is employed, she should be a mid-level executive (Level of Vice President or equivalent) with at least 7 years of work experience.</li>
<li>Completed application forms should be accompanied by a CV and a reference, preferably from the current or immediately previous employer, commenting on applicant's professional achievements and personal attributes.</li>
<li>Applicants nominated by Winpe member firms are not required to provide a reference letter. </li>
<li>Participation is free of charge for women from WInpe member firms and portfolio companies. </li>
<li>Participation in this program is subject to acceptance. Terms & Conditions Apply.</li>
</ul>
<br/><br/>
 <span style={{fontSize:'18px'}}>
<a href="https://proclub.winpeforum.com/static/WinpeProClub_Program_Guidelines.pdf" style={{color: "#22316B", textDecoration: "underline"}} target="_BLANK">Click here</a> to view Program overview .<br/><br/>
</span>
 
 
 <br/> 
 
 Applications are closed. <br/><br/>

Contact <a href="mailto:proclub@winpeforum.com" style={{color: "#22316B", textDecoration: "underline"}} target="_BLANK">info@winpeforum.com</a> for queries. 
        
                   
 */}
 
 
 </div>
<div className="row">
{mentConstant5.map((item, i) => {
  if(i>=13)
  return (
   
   <div className="  col-sm-12 col-md-12  ">
    
      <div className="circle-card" style={{marginBottom:'200px'}}>
            <div className="card-inner" onClick={() => this.togglePopUp(item)}>
            <img  onClick={() => this.togglePopUp(item)}  className="imagess" style={{width:"200px", height:"200px", objectFit:"cover" }} src={item.imgUrl} />
            <div className="overlayy">
            &nbsp;
            </div>
            <div className="cercle">
            &nbsp;
            </div>
            {/*<span className="pop-up"><i className="fa fa-long-arrow-right" /></span>*/}
          <div className="text">
                              

                                <h3 className="circle-name">{item.name} </h3>
                                    <p className="post">{item.post} </p>
                                    <p className="post">{item.company} </p>
                                     <a target="_blank" href={item.linkedIn} className="linkedinbtn btn btn-primary btn-sm" ><i className="fa fa-linkedin"></i></a>
                                </div>
            </div>
      </div>
   </div>
   )
   else 
 return (
    <div className="col-sm-6 col-md-4">
     
      <div className="circle-card"  style={{marginBottom:'200px'}}>
                                <div className="card-inner" onClick={() => this.togglePopUp(item)}>
            <img  onClick={() => this.togglePopUp(item)}  className="imagess" style={{width:"200px", height:"200px", objectFit:"cover" }} src={item.imgUrl} />
                                <div className="overlayy">
                                &nbsp;
                                </div>
                                <div className="cercle">
                                &nbsp;
                                </div>
                                {/*<span className="pop-up"><i className="fa fa-long-arrow-right" /></span>*/}
                                <div className="text">
                                <h3 className="circle-name">{item.name} </h3>
                                    
                                    <p className="post">{item.post} </p>
                                    <p className="post">{item.company} </p>
                                     <a target="_blank" href={item.linkedIn} className="linkedinbtn btn btn-primary btn-sm" ><i className="fa fa-linkedin"></i></a>
                                </div>
                                </div>
   </div> </div>
    )
 })}
</div>





               </div>
               <TeamModal show={isShow} onHide={this.togglePopUp} activeItem={this.state.activeItem} />
            </div>
        </ContentPage>
        )
    }
}
Index.propTypes = {
  location: PropTypes.object
}

export default Index
 


// WEBPACK FOOTER //
// ./src/pages/cohortVI/index.js